import { render, staticRenderFns } from "./DepositResultDialog.vue?vue&type=template&id=5699ab51"
import script from "./DepositResultDialog.vue?vue&type=script&lang=js"
export * from "./DepositResultDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports